import React from "react";
import {Button, Spinner} from "reactstrap";
import {connect} from "react-redux";
import {apiFormSynchronizeTemplatesRequest} from "../thunks/ApiModel";
import {useTranslation} from "react-i18next";

const BtnTemplateSynchronization = ({apiFormSynchronizeTemplatesRequest}) => {
  const {t} = useTranslation();
  const [loader, setLoader] = React.useState(false);
  return <div><Button type="button" outline color="primary" size="sm" className="mb-3 d-flex align-items-center btn-template-synchronization" onClick={() => {
    setLoader(true);
    apiFormSynchronizeTemplatesRequest()
  }}>
    {loader ? <Spinner size="sm" className="mr-1"/> : <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className="mr-1">
      <path fill="#556EE6" d="M12.6663 4.66667C12.6663 4.298 12.3683 4 11.9997 4H6.66634V5.33333H11.333V8.66667H9.33301L11.979 12L14.6663 8.66667H12.6663V4.66667ZM3.33301 11.3333C3.33301 11.702 3.63101 12 3.99967 12H9.33301V10.6667H4.66634V7.33333H6.66634L3.99967 4L1.33301 7.33333H3.33301V11.3333Z"/>
    </svg>}
    {t('synchronize_templates', 'Synchronize templates')}
  </Button></div>
};

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  apiFormSynchronizeTemplatesRequest: () => dispatch(apiFormSynchronizeTemplatesRequest()),
});

export default connect(mapStateToProps, mapDispatchToProps)(BtnTemplateSynchronization);